export const FACEBOOK_MAX_DESCRIPTION_CHARS = 600;
